import { Injectable } from '@angular/core';

import {
  type RenderPresenter,
  injectTellentAssistantRenderPresenters,
} from '@core/tellent-assistant-contracts';

@Injectable({ providedIn: 'root' })
export class ClientToolsRegistry {
  private readonly presenters: readonly RenderPresenter[] =
    injectTellentAssistantRenderPresenters({ optional: true }) ?? [];

  private readonly byIdMap = new Map<string, RenderPresenter>(this.presenters.map(p => [p.id, p]));

  public readonly ids: ReadonlySet<string> = new Set(this.byIdMap.keys());

  public byId(id: string): RenderPresenter | undefined {
    return this.byIdMap.get(id);
  }

  public has(id: string): boolean {
    return this.byIdMap.has(id);
  }
}
